import script from "./OrganismsMapCharts.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsMapCharts.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsMapCharts.vue?vue&type=style&index=0&id=11d82fd0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d82fd0"]])

export default __exports__